import { TFunction } from 'i18next';
import { ProcessPaymentState } from 'shared/types';
import { formatToUSDollars } from 'shared/utils';
import { Yup } from 'shared/yup-extended';
import { getEmailValidationSchema } from 'shared/getEmailValidationSchema';

export type FormValues = {
  firstName: string;
  lastName: string;
  email: string;
  optInToUpdates: boolean;
};

export const isFieldDisabled = (
  isMembershipTransaction: boolean,
  initialState: ProcessPaymentState,
  initialValue: string,
): boolean => {
  const { existingUser, updatePaymentMethod } = initialState;

  if (isMembershipTransaction) {
    return false;
  }

  if (!existingUser || !initialValue) {
    return false;
  }

  return !updatePaymentMethod;
};

export const getPaymentText = (
  t: TFunction,
  isMembershipTransaction: boolean,
  isMembershipUpgrade: boolean | undefined,
  transactionAmount: number,
): string => {
  if (isMembershipTransaction && !isMembershipUpgrade) {
    return t('recurlyAccountInformation.paymentMethod.purchaseMembership');
  }
  if (isMembershipTransaction && isMembershipUpgrade) {
    return t('recurlyAccountInformation.paymentMethod.upgradeMembership');
  }
  return t('recurlyAccountInformation.paymentMethod.donate', {
    amount: formatToUSDollars(transactionAmount),
  });
};

export const getValidationSchema = (
  t: TFunction,
  existingUser: boolean,
  emailValidationCache: Map<string, boolean>,
): Yup.SchemaOf<FormValues> =>
  Yup.object({
    firstName: Yup.string().required(
      t('recurlyAccountInformation.inputs.firstName.required'),
    ),
    lastName: Yup.string().required(
      t('recurlyAccountInformation.inputs.lastName.required'),
    ),
    email: getEmailValidationSchema({
      cache: emailValidationCache,
      skip: existingUser,
      requiredErrMsg: t('recurlyAccountInformation.inputs.email.required'),
      invalidErrMsg: t('recurlyAccountInformation.inputs.email.invalid'),
      registeredErrMsg: t('recurlyAccountInformation.registeredEmail'),
    }),
    optInToUpdates: Yup.boolean().required(
      t('recurlyAccountInformation.inputs.optInToUpdates.required'),
    ),
  });
